<template>
  <layout>
    <bb-container fluid>
      <bb-row class="p-b-60">
        <bb-col md="12" lg="11">
          <section-box :title="translations.bgCurrencyDisplay.title" icon="client-finance-income">
            {{ translations.bgCurrencyDisplay.subtitle }}
          </section-box>
        </bb-col>
        <bb-col md="12" lg="13">
          <bb-form
            @submit="savePreferences"
            :loading="loading"
            :disabled="loading"
            :submit-text="translations.saveChanges">
            <bb-select
              class="m-b-50"
              :noempty="true"
              :options="currencyDisplayOptions"
              v-model="bgCurrencyDisplay"
              name="bgCurrencyDisplay"
              :label="translations.bgCurrencyDisplay.selectLabel"
              :loading="loading"
              :disabled="loading"/>
          </bb-form>
        </bb-col>
      </bb-row>
    </bb-container>
  </layout>
</template>

<script>
import Layout from './Layout'
import SectionBox from '@account/components/SectionBox'
import { mapActions, mapState } from 'pinia'
import { BgCurrencyDisplay } from '@bigbank/dc-common/const/preferences.const'
import { useRootStore } from '@/store/root'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'preferences',
  components: {
    Layout,
    SectionBox
  },
  data () {
    return {
      loading: false,
      bgCurrencyDisplay: 'BGN'
    }
  },
  computed: {
    ...mapState(useRootStore, ['preferences']),
    translations () {
      return {
        bgCurrencyDisplay: {
          title: this.$pgettext('currency_display', 'Currency Display'),
          subtitle: this.$pgettext('currency_display', 'Change the currency display for your account.'),
          selectLabel: this.$pgettext('currency_display', 'Currency')
        },
        saveChanges: this.$pgettext('button', 'Save Changes')
      }
    },
    currencyDisplayOptions () {
      return [
        {
          value: BgCurrencyDisplay.BGN,
          text: this.$pgettext('currency_display', 'BGN')
        },
        {
          value: BgCurrencyDisplay.Both,
          text: this.$pgettext('currency_display', 'BGN/EUR')
        }
      ]
    }

  },
  methods: {
    ...mapActions(useRootStore, ['changePreferences']),
    async savePreferences () {
      this.loading = true
      await this.changePreferences({ bgCurrencyDisplay: this.bgCurrencyDisplay })
      this.loading = false
    }
  },
  async mounted () {
    this.loading = true
    this.bgCurrencyDisplay = this.preferences.bgCurrencyDisplay ?? BgCurrencyDisplay.BGN
    this.loading = false
  }
}
</script>
